/* eslint-disable no-return-assign */
// eslint-disable-next-line import/no-cycle
import axiosIns from '@/libs/axios'
import { toDecrypt } from '@/libs/secret'
import axios from 'axios'
import store from '..'

export default {
  namespaced: true,
  state: {
    selectedRowTable: [],
    selectedRow: null,
    country: [],
    province: [],
    city: [],
    channel: [],
    buyMethod: [],
    buyMethodList: [],
    company: [],
    bidPrice: [],
    schedulingView: {},
    slotTypeBanner: [],
    medium: [],
    // slotTypeBanner: [
    //   { value: 1, text: 'Animated' },
    //   { value: 2, text: 'Expand' },
    //   { value: 3, text: 'Sticky Bottom' },
    //   { value: 4, text: 'Static Banner' },
    //   { value: 5, text: 'Underlay' },
    // ],
    // medium: [
    //   { value: 1, text: 'Internet Positif' },
    //   { value: 2, text: 'Kuota Habis' },
    // ],
    location: [],
    interest: [],
    reasonAccount: [],
    reasonCampaign: [],
    reasonInvoice: [],
    dataInfo: {},
    templateID: [],

    // State Location Segments
    provinceSegments: [],
    kabupatenSegments: [],
    kecamatanSegments: [],
    // End State Location Segment

    // State Selection Segments
    userPersonaSegments: [],
    appSegments: [],
    engagementbyAppSegments: [],
    visitorSegments: [],
    commuterSegments: [],
    neigbourhoodTierSegments: [],
    POICategorySegments: [],
  },
  getters: {
    getCountry: (state) => state.country,
    getProvince: (state) => state.province,
    getCity: (state) => state.city,
    getChannel: (state) => state.channel,
    getBuyMethod: (state) => state.buyMethod,
    getBuyMethodList: (state) => state.buyMethodList,
    getCompany: (state) => state.company,
    getBidPrice: (state) => state.bidPrice,
    getSlotType: (state) => state.slotTypeBanner,
    getMedium: (state) => state.medium,
    getLocation: (state) => state.location,
    getInterest: (state) => state.interest,
    getSelectedRow: (state) => state.selectedRowTable,
    getReasonAccount: (state) => state.reasonAccount,
    getReasonCampaign: (state) => state.reasonCampaign,
    getReasonInvoice: (state) => state.reasonInvoice,
    getDataInfo: (state) => state.dataInfo,
    getDataTemplateID: (state) => state.templateID,

    // Getter Location Segments
    getDataProvinceSegment: (state) => state.provinceSegments,
    getDataKabupatenSegment: (state) => state.kabupatenSegments,
    getDataKecamatanSegment: (state) => state.kecamatanSegments,
    // End Getter Location Segments

    // Getter Selection Segements
    getDataUserPersonaSegment: (state) => state.userPersonaSegments,
    getDataAppSegment: (state) => state.appSegments,
    getDataEngagementbyAppSegment: (state) => state.engagementbyAppSegments,
    getDataVisitor: (state) => state.visitorSegments,
    getDataCommuter: (state) => state.commuterSegments,
    getDataNeigbourhoodTier: (state) => state.neigbourhoodTierSegments,
    getDataPOICategory: (state) => state.POICategorySegments,
    // End Getter Selection Segements
  },
  mutations: {
    setCountry: (state, value) =>
      value ? (state.country = value) : (state.country = []),
    setProvince: (state, value) =>
      value ? (state.province = value) : (state.province = []),
    setCity: (state, value) =>
      value ? (state.city = value) : (state.city = []),
    setChannel: (state, value) =>
      value ? (state.channel = value) : (state.channel = []),
    setBuyMethod: (state, value) =>
      value ? (state.buyMethod = value) : (state.buyMethod = []),
    setBuyMethodList: (state, value) =>
      value ? (state.buyMethodList = value) : (state.buyMethodList = []),
    setCompany: (state, value) =>
      value ? (state.company = value) : (state.company = []),
    setBidPrice: (state, value) =>
      value ? (state.bidPrice = value) : (state.bidPrice = []),
    setSlotType: (state, value) =>
      value ? (state.slotTypeBanner = value) : (state.slotTypeBanner = []),
    setMedium: (state, value) =>
      value ? (state.medium = value) : (state.medium = []),
    setLocation: (state, value) =>
      value ? (state.location = value) : (state.location = []),
    setInterest: (state, value) =>
      value ? (state.interest = value) : (state.interest = []),
    setSchedulingView: (state, value) =>
      value ? (state.schedulingView = value) : (state.schedulingView = []),
    setSelectedRow: (state, value) =>
      value ? (state.selectedRowTable = value) : (state.selectedRowTable = []),
    setReasonAccount: (state, value) =>
      value ? (state.reasonAccount = value) : (state.reasonAccount = []),
    setReasonCampaign: (state, value) =>
      value ? (state.reasonCampaign = value) : (state.reasonCampaign = []),
    setReasonInvoice: (state, value) =>
      value ? (state.reasonInvoice = value) : (state.reasonInvoice = []),
    setDataInfo: (state, value) =>
      value ? (state.dataInfo = value) : (state.dataInfo = {}),
    setTemplateID: (state, value) =>
      value ? (state.templateID = value) : (state.templateID = []),

    // Mutation Location Segments
    setProvinceSegment: (state, value) =>
      value ? (state.provinceSegments = value) : (state.provinceSegments = []),
    setKabupatenSegment: (state, value) =>
      value
        ? (state.kabupatenSegments = value)
        : (state.kabupatenSegments = []),
    setKecamatanSegment: (state, value) =>
      value
        ? (state.kecamatanSegments = value)
        : (state.kecamatanSegments = []),
    // End Mutation Location Segment

    // Mutation Selection Segment
    setPersonaSegment: (state, value) =>
      value
        ? (state.userPersonaSegments = value)
        : (state.userPersonaSegments = []),
    setAppSegment: (state, value) =>
        value
          ? (state.appSegments = value)
          : (state.appSegments = []),
    setEngagementbyAppSegment: (state, value) =>
      value
        ? (state.engagementbyAppSegments = value)
        : (state.engagementbyAppSegments = []),
    setVisitorSegment: (state, value) =>
      value ? (state.visitorSegments = value) : (state.visitorSegments = []),
    setCommuterSegment: (state, value) =>
      value ? (state.commuterSegments = value) : (state.commuterSegments = []),
    setNeigbourhoodTierSegment: (state, value) =>
      value
        ? (state.neigbourhoodTierSegments = value)
        : (state.neigbourhoodTierSegments = []),
    setPOICategorySegment: (state, value) =>
      value
        ? (state.POICategorySegments = value)
        : (state.POICategorySegments = []),
    // End Mutation Selection Segment
  },
  actions: {
    getAllInfo({ commit }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('/generalInfo/keyValue')
          .then((response) => {
            const newData = response.data.data
            commit('setDataInfo', newData)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getAdditionalData({ commit, rootState }) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        axiosIns
          .get('/campaign/newCampaignData', { headers })
          .then((response) => {
            const newData = response.data.data
            commit('setChannel', newData.channel)
            commit('setBuyMethod', newData.buyMethod)
            commit('setBuyMethodList', newData.buy_method)
            commit('setCompany', newData.company)
            commit('setBidPrice', newData.bidPrice)
            commit('setLocation', newData.location)
            commit('setInterest', newData.interest)
            commit('setMedium', newData.medium)
            commit('setSlotType', newData.slot)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    dataReasonCampaign({ commit, rootState }) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        axiosIns
          .get('/reason/type/2', { headers })
          .then((response) => {
            const newData = response.data.data
            commit('setReasonCampaign', newData)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    dataReasonAccount({ commit, rootState }) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        axiosIns
          .get('/reason/type/1', { headers })
          .then((response) => {
            const newData = response.data.data
            commit('setReasonAccount', newData)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    dataReasonInvoice({ commit, rootState }) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        axiosIns
          .get('/reason/type/3', { headers })
          .then((response) => {
            const newData = response.data.data
            commit('setReasonInvoice', newData)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    dataCountry({ commit, rootState }) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        axiosIns
          .get('/country', { headers })
          .then((response) => {
            const newData = response.data
            commit('setCountry', newData)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    dataProvince({ commit, rootState }, payload) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/regency/${payload.id}`, { headers })
          .then((response) => {
            // const newData = responseApi(response.data)
            const newData = response.data
            commit('setProvince', newData)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    dataCity({ commit, rootState }, payload) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/regency/${payload.id}`, { headers })
          .then((response) => {
            // const newData = responseApi(response.data)
            const newData = response.data.data
            commit('setCity', newData)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    dataChannel({ commit, getters, rootState }) {
      if (getters.getProvince.length !== 0) {
        return false
      }
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        axiosIns
          .get('/channel', { headers })
          .then((response) => {
            const newData = response.data
            commit('setChannel', newData)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    dataBuyMethod({ commit, getters, rootState }) {
      if (getters.getProvince.length !== 0) {
        return false
      }
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        axiosIns
          .get('/buy-method', { headers })
          .then((response) => {
            const newData = response.data
            commit('setBuyMethod', newData)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // Action Campaign
    dataTemplateID({ commit, rootState }) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`campaign/gettemplateid`, { headers })
          .then((response) => {
            commit('setTemplateID', response.data.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // Action Location Segments
    dataProvinceSegments({ commit, rootState }) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/iohprovinsi`, { headers })
          .then((response) => {
            commit('setProvinceSegment', response.data.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // END Action Location Segment

    // Action Selection Segment
    dataUserPersonaSegments({ commit, rootState }) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        axios
          .get(`${process.env.VUE_APP_BASE_URLS}userpersona`, {headers})
          .then((response) => {
            let ecr = toDecrypt(response.data.res, store.state.secretKey)
            const dataUserPersona = JSON.parse(ecr)
            commit('setPersonaSegment', dataUserPersona.original.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    dataAppSegments({ commit, rootState }) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        axios
          .get(`${process.env.VUE_APP_BASE_URLS}app_filter`, {headers})
          .then((response) => {
            let ecr = toDecrypt(response.data.res, store.state.secretKey)
            const dataApp = JSON.parse(ecr)
            commit('setAppSegment', dataApp.original.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    dataEngagementbyAppSegments({ commit, rootState }) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        axios
          .get(`${process.env.VUE_APP_BASE_URLS}engagement_group_filter`, {headers})
          .then((response) => {
            let ecr = toDecrypt(response.data.res, store.state.secretKey)
            const dataEngagement = JSON.parse(ecr)
            commit('setEngagementbyAppSegment', dataEngagement.original.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    dataVisitorSegments({ commit, rootState }) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        axios
          .get(`${process.env.VUE_APP_BASE_URLS}visitor_traveller_tag_filter`, {headers})
          .then((response) => {
            let ecr = toDecrypt(response.data.res, store.state.secretKey)
            const dataVisitor = JSON.parse(ecr)
            commit('setVisitorSegment', dataVisitor.original.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    dataCommuterSegments({ commit, rootState }) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        axios
          .get(`${process.env.VUE_APP_BASE_URLS}commuting_pattern`, {headers})
          .then((response) => {
            let ecr = toDecrypt(response.data.res, store.state.secretKey)
            const dataCommuter = JSON.parse(ecr)
            commit('setCommuterSegment', dataCommuter.original.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    dataNeigbourhoodTierSegments({ commit, rootState }) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        axios
          .get(`${process.env.VUE_APP_BASE_URLS}neighborhood_tier`, {headers})
          .then((response) => {
            let ecr = toDecrypt(response.data.res, store.state.secretKey)
            const dataNeigbourhoodTier = JSON.parse(ecr)
            commit('setNeigbourhoodTierSegment', dataNeigbourhoodTier.original.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    dataPOICategorySegments({ commit, rootState }) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        axios
          .get(`${process.env.VUE_APP_BASE_URLS}POI_category`, {headers})
          .then((response) => {
            let ecr = toDecrypt(response.data.res, store.state.secretKey)
            const dataPOICategory = JSON.parse(ecr)
            commit('setPOICategorySegment', dataPOICategory.original.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // End Action Selection Segment
  },
  modules: {},
}
